function CleanExternalString(str) {
    str = String(str); // Convert to string using the String function
    // Strange, yes. But it fixed an IE-specific corruption problem. (Seen specifically with interaction id)
    str = unescape(escape(str)); // Re-encode the string to handle any special characters
    return str;
}

export {
    CleanExternalString
}